"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonCheckListFilter = void 0;
const React = require("react");
const BronsonCheckListFilter = (props) => {
    const optionItem = {
        width: '10%',
        borderRight: '7px solid #fff',
        cursor: 'pointer',
    };
    const label = {
        fontSize: '0.8rem',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontWeight: 'bold',
    };
    return (React.createElement("div", { className: 'o-layout u-bg-alternative u-ml-none u-text-brand' }, props.options.map((option, index) => (React.createElement("div", { title: option.label !== '' ? `Seleccionar ${option.label}` : '', key: `checklist-item-${index}`, id: `checklist-item-${index}`, style: optionItem, className: `o-layout__item u-1/1@s u-m-none u-p-xxsmall u-text-center ${option.selected ? 'u-bg-brand' : ''}`, onClick: () => {
            props.onOptionPicked(option.value);
        } },
        React.createElement("div", null, option.icon),
        React.createElement("p", { style: label }, option.label))))));
};
exports.BronsonCheckListFilter = BronsonCheckListFilter;
